import { render, staticRenderFns } from "./StockSettings.vue?vue&type=template&id=0f2b5bce&scoped=true"
import script from "./StockSettings.vue?vue&type=script&lang=ts"
export * from "./StockSettings.vue?vue&type=script&lang=ts"
import style0 from "./StockSettings.vue?vue&type=style&index=0&id=0f2b5bce&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2b5bce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f2b5bce')) {
      api.createRecord('0f2b5bce', component.options)
    } else {
      api.reload('0f2b5bce', component.options)
    }
    module.hot.accept("./StockSettings.vue?vue&type=template&id=0f2b5bce&scoped=true", function () {
      api.rerender('0f2b5bce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/default/StockSettings.vue"
export default component.exports